import script from "./PermissionsAccordionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsAccordionList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__